import { withBemMod } from '@bem-react/core';
import React from 'react';

import HtmlContent from 'client/common/components/html-content';
import { ILevelVideo } from 'client/common/types';

import { useComponentRegistry } from '@bem-react/di';

import { b, ILevelProps } from '..';

import './level_type_video.css';

export interface ILevelTypeVideoProps extends Omit<ILevelVideo, 'type'> {
    type?: 'video';
}

export const withLevelTypeVideo = withBemMod<ILevelTypeVideoProps, ILevelProps>(
    b(),
    { type: 'video' },
    (BaseLevel: React.FC<ILevelProps>) => props => {
        const { videoSrc, caption, ...otherProps } = props;

        const { VideoIframe } = useComponentRegistry('app');

        return (
            <BaseLevel {...otherProps}>
                <div className={b('content')}>
                    <VideoIframe className={b('video')} videoSrc={videoSrc} />
                    {caption && <HtmlContent className={b('caption')} content={caption} />}
                </div>
            </BaseLevel>
        );
    }
);
